export const getDetectionImageUrl = ({
  originalSourceUrl = '',
  newProjectImageUrl = '',
  userId = '',
  projectName = '',
  savedFallbackUrl = '',
}) => {
  if (originalSourceUrl) return originalSourceUrl;
  if (newProjectImageUrl) return newProjectImageUrl;

  if (userId && projectName) {
    const filename = `${projectName.replaceAll(' ', '_')}_${userId}`;
    const path = `usersProjectsImages/${userId}/canvasImages/${filename}`;
    return `https://firebasestorage.googleapis.com/v0/b/facadewebapp.appspot.com/o/${encodeURIComponent(path)}?alt=media`;
  }

  return savedFallbackUrl;
};
